
// :::::::::: Code for ADA issues Start :::::::::: //
function updateReviewsButtonRoleNew() {
    const buttons = document.querySelectorAll('.slideshow-reviews-section .slick-dots button[aria-pressed]');
    if(buttons && buttons.length > 0){
        buttons.forEach(button => {
            button.setAttribute('role', 'tab');

            if(button.getAttribute('aria-pressed') == 'true'){
                button.setAttribute('aria-selected', 'true');
            }
            if(button.getAttribute('aria-pressed') == 'false'){
                button.setAttribute('aria-selected', 'false');
            }

            button.removeAttribute('aria-pressed');
        });
        clearInterval(updateReviewsButtonRoleIdNew);
    }
}
const updateReviewsButtonRoleIdNew = setInterval(() => { updateReviewsButtonRoleNew(); }, 1000);

function updateReviewsButtonRole() {
    const slickTrack = document.querySelector('.slideshow-reviews-section .slideshow-reviews .slick-track');
    const slickSlide = document.querySelectorAll('.slideshow-reviews-section .slideshow-reviews .slick-slide');
    const slickDots  = document.querySelector('.slideshow-reviews-section .slideshow-reviews .slick-dots');
    const slickDotsList = document.querySelectorAll('.slideshow-reviews-section .slideshow-reviews .slick-dots li');

    if(slickSlide && slickSlide.length > 0 && slickDotsList && slickDotsList.length > 0){
        slickTrack.removeAttribute('role');
        slickSlide.forEach(slide => {
            slide.removeAttribute('role');
        });
        
        slickDots.removeAttribute('role');
        slickDotsList.forEach(dot => {
            dot.removeAttribute('role');
        });
        clearInterval(updateReviewsButtonRoleId);
    }
}
const updateReviewsButtonRoleId = setInterval(() => { updateReviewsButtonRole(); }, 1000);
  

function updateTestimonialButtonRole() {
    const sliderTrack = document.querySelector('.testimonial-grid__slider .slick-track');
    const buttons = document.querySelectorAll('.testimonial-grid__slider .slick-dots button[aria-pressed]');
    const slide = document.querySelectorAll('.testimonial-grid__slider .slick-slide');
    const dotList = document.querySelector('.testimonial-grid__slider .slick-dots');
    const dots = document.querySelectorAll('.testimonial-grid__slider .slick-dots li');
    if(slide && slide.length > 0 || buttons && buttons.length > 0){
        sliderTrack.removeAttribute('role');
        slide.forEach(slide => {
            slide.removeAttribute('role');
        });
        buttons.forEach(button => {
            button.setAttribute('role', 'tab');
            console.log('gettt',button.getAttribute('aria-pressed'))

            if(button.getAttribute('aria-pressed') == 'true'){
                button.setAttribute('aria-selected', 'true');
            }
            if(button.getAttribute('aria-pressed') == 'false'){
                button.setAttribute('aria-selected', 'false');
            }

            button.removeAttribute('aria-pressed');
        });
        dotList.removeAttribute('role');
        dots.forEach(dot => {
            dot.removeAttribute('role');
        });
        clearInterval(updateTestimonialButtonRoleId);
    }
}
const updateTestimonialButtonRoleId = setInterval(() => { updateTestimonialButtonRole(); }, 1000);

function updateTrialButtonRole() {
    const buttons = document.querySelectorAll('.trial-grid__trial-wrapper .slick-dots button[aria-pressed]');
    if(buttons && buttons.length > 0){
        buttons.forEach(button => {
            button.setAttribute('role', 'tab');
            console.log('gettt',button.getAttribute('aria-pressed'))

            if(button.getAttribute('aria-pressed') == 'true'){
                button.setAttribute('aria-selected', 'true');
            }
            if(button.getAttribute('aria-pressed') == 'false'){
                button.setAttribute('aria-selected', 'false');
            }

            button.removeAttribute('aria-pressed');
        });
        clearInterval(updateTrialButtonRoleId);
    }
}
const updateTrialButtonRoleId = setInterval(() => { updateTrialButtonRole(); }, 1000);

const jadserveImageUrl = "https://jadserve.postrelease.com/rt.gif";
function checkImagePresence() {
  const images = document.getElementsByTagName('img');
  for (let img of images) {
    if (img.src.includes(jadserveImageUrl)) {
        img.alt = "gif image";
        return true;
    }
  }
  return false;
}
if (!checkImagePresence()) {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if (checkImagePresence()) {
          observer.disconnect();
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function updateLifestyleButtonRole() {
    const slickTrack = document.querySelector('.lifestyle-grid__lifestyle-wrapper .slick-track');
    const slickSlide = document.querySelectorAll('.lifestyle-grid__lifestyle-wrapper .slick-slide');
    const slickDots  = document.querySelector('.lifestyle-grid__lifestyle-wrapper .slick-dots');
    const slickDotsList = document.querySelectorAll('.lifestyle-grid__lifestyle-wrapper .slick-dots li');

    if(slickSlide && slickSlide.length > 0 && slickDotsList && slickDotsList.length > 0){
        slickTrack.removeAttribute('role');
        slickSlide.forEach(slide => {
            slide.removeAttribute('role');
        });
        
        slickDots.removeAttribute('role');
        slickDotsList.forEach(dot => {
            dot.removeAttribute('role');
        });
        clearInterval(updateLifestyleButtonRoleId);
    }
}
const updateLifestyleButtonRoleId = setInterval(() => { updateLifestyleButtonRole(); }, 1000);

function updateResponderButtonRole() {
    const slickTrack = document.querySelector('#shopify-section-responder-product-grid .slick-track');
    const slickSlide = document.querySelectorAll('#shopify-section-responder-product-grid .slick-slide');
    const slickDots  = document.querySelector('#shopify-section-responder-product-grid .slick-dots');
    const slickDotsList = document.querySelectorAll('#shopify-section-responder-product-grid .slick-dots li');

    if(slickSlide && slickSlide.length > 0 && slickDotsList && slickDotsList.length > 0){
        slickTrack.removeAttribute('role');
        slickSlide.forEach(slide => {
            slide.removeAttribute('role');
        });
        
        slickDots.removeAttribute('role');
        slickDotsList.forEach(dot => {
            dot.removeAttribute('role');
        });
        clearInterval(updateResponderButtonRoleId);
    }
}
const updateResponderButtonRoleId = setInterval(() => { updateResponderButtonRole(); }, 1000);

function updateAdvantageButtonRole() {
    const slickTrack = document.querySelector('#shopify-section-compare-advantage-grid .advantage-grid__slider .slick-track');
    const slickSlide = document.querySelectorAll('#shopify-section-compare-advantage-grid .advantage-grid__slider .slick-slide');
    const slickDots  = document.querySelector('#shopify-section-compare-advantage-grid .advantage-grid__slider .slick-dots');
    const slickDotsList = document.querySelectorAll('#shopify-section-compare-advantage-grid .advantage-grid__slider .slick-dots li');

    if(slickSlide && slickSlide.length > 0 && slickDotsList && slickDotsList.length > 0){
        slickTrack.removeAttribute('role');
        slickSlide.forEach(slide => {
            slide.removeAttribute('role');
        });
        
        slickDots.removeAttribute('role');
        slickDotsList.forEach(dot => {
            dot.removeAttribute('role');
        });
        clearInterval(updateAdvantageButtonRoleId);
    }
}
const updateAdvantageButtonRoleId = setInterval(() => { updateAdvantageButtonRole(); }, 1000);

// $(document).ready(function(){
//     $('.slideshow-reviews-section').on('init', function(event, slick){
//       $('.slick-dots li button').each(function(index){
//         $(this).attr('role', 'tab');
//        });
//     });
//     setTimeout(function(){
//       $('.slideshow-reviews-section').slick();
//     }, 5000);
// });
